import { render, staticRenderFns } from "./BookingDialogStepShop2.vue?vue&type=template&id=74f3c692&"
import script from "./BookingDialogStepShop2.vue?vue&type=script&lang=js&"
export * from "./BookingDialogStepShop2.vue?vue&type=script&lang=js&"
import style0 from "./BookingDialogStepShop2.vue?vue&type=style&index=0&id=74f3c692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmallCardProduct2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/SmallCardProduct2.vue').default,CardAddress: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CardAddress.vue').default})
